var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpUtilita(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.1448,
    r: 30,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8508 21.8747C36.8508 18.0247 34.0508 15.9547 29.8808 15.9547C26.7608 15.9547 24.1608 17.2147 22.8808 19.6647C22.5708 20.2547 21.8508 20.5047 21.2708 20.1747C20.7108 19.8647 20.5108 19.1647 20.8008 18.5947C22.4908 15.2647 26.0508 13.6047 29.8808 13.6047C35.0208 13.6047 39.3308 16.4447 39.3308 21.8547C39.3308 28.4147 31.3308 30.6947 30.5008 36.8947C30.4208 37.4947 29.9108 37.9447 29.3008 37.9447C28.5708 37.9447 27.9908 37.3047 28.0908 36.5747C29.0108 29.6247 36.8508 27.5847 36.8508 21.8447V21.8747ZM27.1808 44.6247C27.1808 43.4747 28.0508 42.5647 29.2408 42.5647C30.4308 42.5647 31.3008 43.4847 31.3008 44.6247C31.3008 45.7647 30.3808 46.6847 29.2408 46.6847C28.1008 46.6847 27.1808 45.7647 27.1808 44.6247Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpUtilita);
export default __webpack_public_path__ + "static/media/help-utilita.6cd247fbd5821e240a2cbc7af035d76a.svg";
export { ForwardRef as ReactComponent };